import { TranslateService } from '@ngx-translate/core';
import { SessionsService } from '../../sessions.service';
import { UsersService } from '../../users/users.service';
import { Component, OnInit } from '@angular/core';
import { WizardService } from '../../wizard/wizard.service';
import { ISession } from '../../../../models/session';
import { FormBuilder, Validators } from '@angular/forms';
import { environment as config } from '../../../../../environments/environment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { isEmpty, isNil } from 'ramda/es';
import 'rxjs/add/operator/toPromise';
import { EmailService } from '../../../email/email.service';
import { firstDateBeforeSecond } from '../../../../validators/first-date-before-second';
import { step3 } from '../step';
import { ThemeService } from '../../../../theme/theme.service';
import { IWizardCol } from '../../wizard/wizard-col.component';
import { ThemeDirective } from '../../../../theme/theme.directive';
import * as store from 'store';
import { filter, tap } from 'rxjs/operators';
import { PluginsService } from '../../../plugins/plugins.service';
import { eva_constants } from '../../../../eva_constants';

@Component({
  selector: 'step-3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.scss']
})
export class Step3Component implements OnInit {
  form = new WizardService().getSessionSubscription();
  sessionForm: any;
  loading = false;
  warn = false;
  public step3: IWizardCol = step3[eva_constants.EVA_THEME];
  public theme: String = eva_constants.EVA_THEME;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private wizardService: WizardService,
    private sessionsService: SessionsService,
    private translate: TranslateService,
    private usersService: UsersService,
    private emailService: EmailService,
    private pluginsService: PluginsService,
    private fb: FormBuilder
  ) {
    this.sessionForm = this.fb.group(
      {
        name: ['', [Validators.required, Validators.maxLength(50)]],
        date: ['', Validators.required],
        expirationdatetime: ['', Validators.required]
      },
      { validator: firstDateBeforeSecond('date', 'expirationdatetime') }
    );
  }

  get name() {
    return this.sessionForm.get('name');
  }

  ngOnInit() {
    this.sessionForm.valueChanges.subscribe(data => {
      data.speaker = 'Mister Speaker';
      data.date = new Date(data.date);
      this.form.next(data);
      const wizardService = new WizardService();
      wizardService.getSessionTypeSubscription().subscribe(res => {
        this.warn = res === 'mixte' || res === 'interactive';
      });
    });

    
    if (this.route && this.route.data) {
      this.route.data.subscribe(data => {
        this.bindTheme(data);
      });
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          const { data } = this.route.snapshot.firstChild;
          this.bindTheme(data);
        })
      )
      .subscribe(null);
  }


  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    if (data.theme) {
      this.theme = data.theme;
      this.step3 = step3[data.theme];
    }
  }

  addSession() {
    const wizardService = new WizardService();
    toastr.warning(this.translate.instant('sessions.create.slow_warning'));
    this.loading = true;
    const postCreation = [
      {
        func: this.sessionsService.close,
        bind: this.sessionsService,
        data: { sessionType: 'vod' },
        use: (session: ISession) => {
          return session.types.sessionType === 'vod';
        }
      },
      {
        func: this.usersService.updateRegistration,
        bind: this.usersService,
        data: { data: wizardService.getRegistrationFormSubscription().value.fields },
        use: (session: ISession) => true
      },
      {
        func: this.usersService.updateGenericLogin,
        bind: this.usersService,
        data: wizardService.getUniqueLoginSubscription().value,
        use: (session: ISession) => true
      },
      {
        func: this.emailService.applyEmailTemplate,
        bind: this.emailService,
        data: { sessionType: 'interactive' },
        use: (session: ISession) => {
          return session.types.sessionType === 'interactive';
        }
      },
      {
        func: this.pluginsService.toggleOnly,
        bind: this.pluginsService,
        data: { pluginName: 'video_replay_publish' },
        use: (session: ISession) => {
          return session.types.sessionType === 'vod';
        }
      }
    ];
    const session = this.form.value;
    session.types = {
      privacy: wizardService.getPrivacySubscription().value,
      accountType: wizardService.getAccountTypeSubscription().value,
      sessionType: wizardService.getSessionTypeSubscription().value
    };
    this.sessionsService
      .create(session, false)
      .toPromise()
      .then((session: ISession) => {
        return Promise.all(
          postCreation
            // Filter unnecessary post-creation processes
            .filter(f => !isEmpty(f.data) && !isNil(f.data) && f.use(session))
            .map(f => {
              const func = f.func.bind(f.bind);
              return func(session, f.data, false).toPromise();
            })
        );
      })
      .then(() => {
        toastr.success(this.translate.instant('sessions.create.session_created'));
        this.router.navigate(['/sessions']);
      })
      .catch(() => {
        this.loading = false;
        toastr.error(this.translate.instant('sessions.create.session_not_created'));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/step/step3.component.ts